import { useTranslation } from 'react-i18next';
import { FormControl } from '@material-ui/core';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { notesInitialValue } from '../../../util/initial-values';

const noteInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementOwingParty,
    isOptional : false,
    label      : 'Owing Party',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementBalanceOwed,
    isOptional : false,
    label      : 'Balance Owed',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementMonthlyPayment,
    isOptional : false,
    label      : 'Monthly Payment',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementMaturityDate,
    isOptional : true,
    label      : 'Maturity Date',
    type       : DynamicFormFieldArrayType.DATE_FUTURE,
  },
  {
    fieldName  : FieldNames.financialStatementNotePurpose,
    isOptional : true,
    label      : 'Purpose',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this held jointly',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const noteProps: DynamicFormFieldArray = {
  addButtonText: 'Account',
  initialValue: notesInitialValue,
  inputs: noteInputs,
};

export const NotesFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: noteProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
